var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-alert",
    {
      staticClass: "alert error-alert",
      attrs: { variant: "success", dismissible: "" },
      model: {
        value: _vm.showAlert,
        callback: function($$v) {
          _vm.showAlert = $$v
        },
        expression: "showAlert"
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.message) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Alerts/SuccessAlert.vue?vue&type=template&id=483412ee&scoped=true&
// module id = null
// module chunks = 